import _ from 'lodash';
import { bookingConstants } from "utils/constants/booking-constants";
import ObjectBuildingParkingSpace from "utils/objects/building-parking-space";
import ObjectClass from "utils/objects/object";
import { transportConstants } from "utils/constants/transport-constants";
import HelperArray from "utils/helper-array";
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { collectTimeslotCapacity } from 'utils/timeslot-capacity'
import HelperString from 'utils/helper-string'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import HelperDate, { dateFormat } from 'utils/helper-date'

const ObjectTimeslot = {
	
	/**
	 *
	 * @param object
	 * @returns {unknown[]|*[]}
	 */
	parse: ( object ) => {
		if( 'timeslots_through' in object ) {
			return _.get( object, 'timeslots_through', [] );
		}
		
		if( 'timeslots' in object ) {
			return _.map( _.get( object, 'timeslots', [] ), item => {
				if( 'guid' in item ) {
					return item;
				}
				
				return _.get( item, 'timeslot', {} );
			});
		}
		
		return [];
	},
	
	/**
	 *
	 * @param objects
	 * @returns {*[]}
	 */
	filter: ( objects ) => {
		return ObjectClass.filterActive( objects );
	},
	
	/**
	 *
	 * @param objects
	 */
	order: ( objects ) => {
		return _.sortBy(
			objects,
			[ 'timeslot_day', 'timeslot_start' ]
		);
	},
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param objects
	 * @returns {objects[]}
	 */
	filterAndOrder: ( objects ) => {
		return ObjectTimeslot.order( ObjectTimeslot.filter( objects ) );
	},
	
	/**
	 *
	 * @param building
	 * @param floor
	 * @param room
	 * @param roomKind
	 * @returns {{}}
	 */
	find: ( { building = {}, floor = {}, room = {}, timeslotKinds = timeslotKindConstants } = {} ) => {
		let result = {};
		
		const availableTimeslotDays = [];
		
		const list = {
			'building': building,
			'floor': floor,
			'room': room,
		}

		_.forEach( list, ( data, dataKey ) => {
			if( !_.isEmpty( data ) ) {
				const parsed = ObjectTimeslot.filterAndOrder( ObjectTimeslot.parse( data ) );
				if( _.size( parsed ) > 0 ) {
					_.forEach( timeslotKinds, kind => {
						// When meeting room change the kind
						let filterKind = kind;
						//if( roomKind === roomConstants.KIND_MEETING_ROOM ) {
						//	// Skip lunch when meeting room
						//	if( [ bookingConstants.LUNCH ].includes( kind ) ) {
						//		return;
						//	}
						//
						//	// Transform booking to meeting room
						//	if( [ bookingConstants.BOOKING ].includes( kind ) ) {
						//		filterKind = bookingConstants.MEETING_ROOM;
						//	}
						//}
						
						const filtered = _.filter( parsed, o => {
							return _.get(o, 'kind', null) === filterKind;
						} );
						
						if( _.size( filtered ) > 0 ) {
							_.forEach( filtered, f => {
								f['timeslot_by'] = dataKey;
								
								if( !_.includes( availableTimeslotDays, f['timeslot_day'] ) ) {
									availableTimeslotDays.push( f['timeslot_day'] );
								}
							});
							
							switch( kind ) {
								case bookingConstants.TRANSPORT:
									const newFiltered = [];
									
									_.forEach( filtered, filter => {
										_.forEach( [ transportConstants.CAR ], transportKind => {
											
											const buildingParkingSpaces = ObjectBuildingParkingSpace.find( building.guid, transportKind );
											if( _.size( buildingParkingSpaces ) > 0 ) {
												_.forEach( buildingParkingSpaces, buildingParkingSpace => {
													newFiltered.push({
														...filter,
														transport_kind: transportKind,
														building_parking_space: buildingParkingSpace
													})
												})
											} else {
												newFiltered.push({
													...filter,
													transport_kind: transportKind
												})
											}
										})
									})
									
									result[ kind ] = newFiltered;
									break;
									
								case bookingConstants.BOOKING:
								case bookingConstants.MEETING_ROOM:
									// TODO 'fix' When roomKind is meeting and the current room is not room then skip
									
									result[ kind ] = filtered;
									break;
								
								default:
									result[ kind ] = filtered;
							}
						}
					})
				}
			}
		});
		
		return result;
	},
	
	groupTimeSlots: ( timeslots, { disableKindBooking = false, parse = false } = {} ) => {
		if( parse ) {
			timeslots = ObjectTimeslot.parse( timeslots );
		}

		timeslots = _.orderBy( timeslots, 'timeslot_start', 'asc' );
		
		const groupedTimeslots = [];
		if( _.size( timeslots ) > 0 ) {
			
			_.forEach( timeslots, timeslot => {
				
				// Added check if timeslot is null
				if( timeslot !== null && typeof timeslot !== 'undefined' && ObjectClass.isActive( timeslot ) ) {

					const data = {
						kind: timeslot.kind,
						sub_kind: timeslot.sub_kind,
						timeslot_start: timeslot.timeslot_start,
						timeslot_end: timeslot.timeslot_end,
						capacity: timeslot.capacity,
						translations: timeslot.translations,
					}
					
					const result = _.findKey( groupedTimeslots, data )
					
					//if ( !( key in groupedTimeslots ) ) {
					if( _.isEmpty( result ) ) {
						// Skip when this
						if( disableKindBooking && timeslot?.kind === timeslotKindConstants.BOOKING ) {
							return;
						}
						
						const key = `timeslot|${ timeslot?.kind }-${ timeslot?.sub_kind }-${ timeslot?.timeslot_end }-${ timeslot?.timeslot_start }|${ HelperString.random() }`;

						groupedTimeslots.push({
							...data,
							key: key,
							timeslots: [
								timeslot
							]
						});
					} else {
						groupedTimeslots[ result ].timeslots.push( timeslot );
					}
				}
			} );
		}
		
		let result = {};
		_.forEach( groupedTimeslots, i => {
			result[ i.key ] = i
		})
		
		return result;
	},
	
	getCapacity: ( object ) => {
		const itemKey = FetchTimeslotCapacity.keyByBooking( object );
		
		const _timeslotsOccupied = store.getState().data[ dataConstants.TIMESLOTS_OCCUPIED ];
		
		return _.get( _timeslotsOccupied, [ itemKey ], {} );
	},
	
	/**
	 *
	 * @param object
	 * @param timeslotCapacity
	 * @returns {{isInvitation: boolean, isTimeslotAvailable: boolean, placesAvailable: number, capacity: null, isTimeslotBooked: boolean, isInvited: boolean, bookForMyself, bookForMultiple, personAmount: number, defaultEmployeeAmount: number, employees: commander.ParseOptionsResult.unknown[], employeeDidAlreadyBook: boolean, personsSelectedSize: number, enoughPlacesAvailable: boolean}}
	 */
	collect: ( object, { timeslotCapacity } = {} ) => {
		return collectTimeslotCapacity( object, timeslotCapacity || ObjectTimeslot.getCapacity( object ), store.getState().cart );
	},

	/**
	 *
	 */
	isAfterOrBefore: ( startTime, endTime, compareStartDate, compareEndDate ) => {
		// Setup date
		const dateStart = HelperDate.date( startTime, dateFormat.FULL_TIME );
		const dateEnd = HelperDate.date( endTime, dateFormat.FULL_TIME );
		
		// Init the variables
		let isAfterOrBefore = false;
		
		let newStartDate = (compareStartDate === null) ? dateStart : null;
		let newEndDate = (compareEndDate === null ) ? dateEnd : null;
		
		//
		if( compareStartDate === null && compareEndDate === null ) {
			isAfterOrBefore = true;
		}
		
		// When the new start time is the same as the last known end time then add it
		if( dateStart.isSame( compareEndDate ) ) {
			isAfterOrBefore = true;
			
			// Update the end time
			if( dateEnd.isAfter( compareEndDate ) ) {
				newEndDate = dateEnd;
			}
		} else {
			
			// When the new end time is the same as the last known start time
			if( dateEnd.isSame( compareStartDate ) ) {
				isAfterOrBefore = true;
				
				// Update the start time
				if( dateStart.isBefore( compareStartDate ) ) {
					newStartDate = dateStart;
				}
			}
		}
		
		return {
			isAfterOrBefore,
			newStartDate,
			newEndDate,
			comparedStartTime: dateStart,
			comparedEndTime: dateEnd
		}
	},
	
	/**
	 *
	 * @param timeslots
	 * @param asArray
	 */
	groupTimeslotTime: ( timeslots, asArray = false ) => {
		// First order by the start time
		timeslots = _.orderBy( timeslots, 'timeslot_start', 'asc' );
		
		let listKey = 0;
		let list = {};
		
		_.map( timeslots, timeslot => {
			// Check the time
			const { isAfterOrBefore, newStartDate, newEndDate, comparedStartTime, comparedEndTime } = ObjectTimeslot.isAfterOrBefore(
				timeslot.timeslot_start,
				timeslot.timeslot_end,
				_.get( list, [ listKey, 'start' ], null ),
				_.get( list, [ listKey, 'end' ], null ),
			)
			
			// Create a new key?
			//if( !isAfterOrBefore && ( newStartDate !== null || newEndDate !== null ) ) {
			if( !isAfterOrBefore  ) {
				listKey = listKey + 1;
			}
			
			// Create the list
			if( !_.has( list, listKey ) ) {
				list[ listKey ] = {
					start: comparedStartTime,
					end: comparedEndTime,
				}
			}
			
			// Update the parameters
			if( newStartDate !== null ) {
				list[ listKey ].start = newStartDate;
			}
			
			if( newEndDate !== null ) {
				list[ listKey ].end = newEndDate;
			}
		})
		
		// Combine the time
		let stringList = [];
		_.forEach( list, o => {
			stringList.push(
				`${ o.start.format( dateFormat.SHORT_TIME ) } - ${ o.end.format( dateFormat.SHORT_TIME ) }`
			);
		})
		
		stringList = _.uniq( stringList )
		
		// Join to a nice string
		return asArray ? stringList : HelperArray.naturalJoin( stringList )
	},
}

export default ObjectTimeslot
